<his-multiselect-plam
	[ddKey]="researchAreaDdKey"
	dataSource="researchAreaValue"
	[selectedOptions]="selectedResearchAreas"
	(selectedOptionsChange)="onSelectedResearchAreasChange($event)"
	field="text"
	[editMode]="editMode">
</his-multiselect-plam>
